import React from 'react'

interface IProps {
  children: any
  className?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const IconButton: React.FC<IProps> = ({ className = '', children, onClick }) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <button onClick={handleClick} className={`bg-gray-100 ${className}`}>
      {children}
    </button>
  )
}

export default IconButton
